import {constants} from '@newsela/angelou';
import {css} from 'emotion';

const {ui} = constants.colors;

export const licenseContainer = css({
  display: 'flex',
  width: '90%',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 0px',
});

export const productListContainer = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  paddingBottom: '16px',
  cursor: 'default',
});

export const productList = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  ul: {
    width: '90%',
    listStyle: 'disc',
    backgroundColor: ui.greyExtraLight,
    borderRadius: '8px',
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingLeft: '32px',

    li: {
      listStyleType: 'disc',
    }
  }
});

export const sectionLabel = css({
  textTransform: 'uppercase',
  fontSize: '12px',
  color: ui.greyLight,
});

export const trialDays = css({
  alignSelf: 'flex-end',
  fontSize: '12px',
  paddingRight: '16px',
  color: ui.red,
});
